


































































import Vue from 'vue';
export default Vue.extend({
  data() {
    return {
      showPassword: false,
      rules: [(value: string) => !!value || 'Required.'],
    };
  },
  props: {
    dialog: Boolean,
    item: Object,
    error: Boolean,
    success: Boolean,
    disableSubmit: Boolean,
    loading: Boolean,
    typeOrbc: Function,
  },
});
